import React, { Component } from 'react';
import firebase from 'firebase/app';
import { Link } from 'react-router-dom'
let FontAwesome = require('react-fontawesome');

class FavoritesPage extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            restaurants: props.restaurants,
            value: 'recent'
        };
    }

    componentDidMount() {
        this.restaurantsRef = firebase.database().ref(`restaurants/${this.props.match.params.uid}/favorites`);
        this.restaurantsRef.on('value', (snapshot) => {
            this.setState({
                restaurants: snapshot.val()
            });
        });
    }

    componentWillUnmount() {
        this.restaurantsRef.off();
    }

    handleChange = (event) => {
        this.setState({ value: event.target.value });
    }

    render() {
        if (!this.state.restaurants) return (
                <section id="favorites">
                    <div className="container">
                                    <div className="row align-items-center h-100">
                                        <div id="homescreen" className="col-xs-12 col-lg-12 mx-auto">
                                            <div id="logo">
                                                <Link to="/"><img src={process.env.PUBLIC_URL + "/img/grubrun-logo-ml.png"} width="500" alt="Grub Run logo art" /></Link>
                                            </div>
                        <p className=""><em>We're to blame, for always choosing the right place.</em></p>
                                        </div>
                                    </div>    
                        <div className="section-title">
                            <h2><span>My</span> Favorites</h2>
                        </div>
                        <div className="text-center">
                        <p className='text-center white'>Add some restaurants to the list!</p>
                        </div>
                    </div>
                </section>
        ); //if no restaurants, don't display

        let restaurantKeys = Object.keys(this.state.restaurants);
        let restaurantObjects = restaurantKeys.map((key) => {
            let restaurantObj = this.state.restaurants[key];
            restaurantObj.id = key;
            return restaurantObj;
        });

        if (this.state.value === 'recent') {
            restaurantObjects.sort(function (a, b) {
                return b.time - a.time;
            });
            restaurantObjects.reverse();
        } else if (this.state.value === 'rating') {
            restaurantObjects.sort(function (a, b) {
                return a.rating - b.rating;
            });
            restaurantObjects.reverse();
        } else {
            restaurantObjects.sort(function(a, b) {
                return b.review_count - a.review_count;
            });
        }

        let restaurantItems = restaurantObjects.map((obj) => {
            return <RestaurantItem restaurant={obj} uid={this.props.match.params.uid} key={obj.id} />
        });

        return (
            <section id="favorites">
                <div className="container">
                    <div className="row align-items-center h-100 justify-content-center">
                        <div id="homescreen" className="col-xs-12 col-lg-12 mx-auto">
                            <div id="logo">
                                <Link to="/"><img src={process.env.PUBLIC_URL + "/img/grubrun-logo-ml.png"} width="500" alt="Grub Run logo art" /></Link>
                            </div>
                            <p className=""><em>We're to blame, for always choosing the right place.</em></p>
                        </div>
                    </div>
                    <div className="section-title justify-content-center">
                        <h2><span>My</span> Favorites</h2>
                    </div>
                    <div className="col-xs-12 col-lg-9 mx-auto">
                         <div className="row bottom-space justify-content-center">
                            <label for="select" className="space">Sort by</label>
                            <select id="select" className="d-block" onChange={this.handleChange}>
                                <option value="recent">Most Recent</option>
                                <option value="rating">Best Rating</option>
                                <option value="review">Highest Reviews</option>
                            </select>
                        </div>
                        <ul className='inline-center'>
                            {restaurantItems}
                        </ul>
                    </div>
                </div>
            </section>
        );
    }
}

//A single restaurant
class RestaurantItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            removed: false
        }
    }
    removeRestaurant(restaurant) {
        let firebaseRef = firebase.database().ref(`/restaurants/${this.props.uid}/favorites`);

        firebaseRef.child(`${restaurant.id}`).remove();
        this.setState({
            removed: true
        });
    }

    render() {
        let stars = {0:'regular_0.png', 1:'regular_1.png', 1.5:'regular_1_half.png', 2:'regular_2.png', 2.5:'regular_2_half.png', 
                    3:'regular_3.png', 3.5:'regular_3_half.png', 4:'regular_4.png', 4.5:'regular_4_half.png', 5:'regular_5.png'}

        if (!this.state.removed) {
            let restaurant = this.props.restaurant; //current restaurant (convenience)
            let mapUrl = `https://www.google.com/maps/search/?api=1&query=${restaurant.coordinates.latitude},${restaurant.coordinates.longitude}`;
            let rating = process.env.PUBLIC_URL + '/img/stars/' + stars[restaurant.rating];
            var status;
            if (restaurant.is_closed) {
                status = "Closed";
            } else {
                status = "Open";
            }
            return (
                <li className="dividers justify-content-center">
                    <div className='container'>
                        {/* <div className="card"> */}
                            <div className="row">
                            <div className="col-sm-4 img-results">
                                <img id="favImg" className="img-results" src={restaurant.image} alt="restaurant pic" />
                            </div>
                            <div className="col-sm-6">
                                <h3 id="resultsname" className="margins"><a href={restaurant.url} className="fav-title" target="_blank">{restaurant.name}</a></h3>
                                <p>
                                    <img src={rating} alt="rating" /> <strong>{restaurant.review_count}</strong> reviews
                                </p>
                                <p ><span className='open-close'>{status}&emsp;</span>{restaurant.phone}</p>
                                <p>
                                    <a id="mapUrl" href={mapUrl}>
                                        <FontAwesome name='map-pin' />
                                        &nbsp;&nbsp;&nbsp;<strong>Get directions</strong>
                                    </a>
                                </p>
                            </div>
                            <div className="col-sm-2">
                                <button id='removelist' onClick={() => this.removeRestaurant(restaurant)} type="button" className='close' aria-label='Close'>
                                     <span aria-hidden='true'>&times;</span>
                                </button>
                                
                            </div>
                            
                        </div>
                        {/* </div> */}
                    </div>
                </li>
            );
        } else {
            return (<div></div>);
        }
    }
}

export default FavoritesPage;